import { TagModule } from "@/store/modules/tag.module";
import { toaster } from "@/utilities/toaster";
import { assign, Machine } from "xstate";
const tagsListingMachine = Machine({
    id: "tagMachine",
    context: {
        searchData: {
            page: 1,
            pageSize: 10,
            sort: {
                field: "tagName",
                type: "asc",
            },
            columnFilters: [],
        },
        ispageChanged: false,
    },
    initial: "idle",
    states: {
        idle: {
            on: {
                GETTING_TAGS: { target: "gettingTags" },
            },
        },
        gettingTags: {
            invoke: {
                id: "gettingTags",
                src: (context, event) => {
                    return TagModule.GetTags(context.searchData);
                },
                onDone: { target: "loadedTags" },
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedTags: {
            on: {
                GETTING_TAGS: { target: "gettingTags", actions: "assignSearchData" },
                DELETE_TAG: { target: "deleteTag", actions: "ispageChanged" },
                ADD_TAG: { target: "addTags" },
                EDIT_TAG: { target: "editTags" },
            },
        },
        addTags: {
            tags: "showAddTagModal",
            on: {
                ADDING_TAG: { target: "addingTags" },
                CANCEL_TAG: { target: "loadedTags" },
            },
        },
        addingTags: {
            tags: "showAddTagModal",
            invoke: {
                id: "addingTags",
                src: (context, event) => {
                    return TagModule.AddTag(event.tag);
                },
                onDone: { target: "gettingTags", actions: "showAddMessage" },
                onError: { target: "addTags" },
            },
        },
        editTags: {
            tags: "showEditTagModal",
            on: {
                UPDATING_TAG: { target: "updatingTags" },
                CANCEL_TAG: { target: "loadedTags" },
            },
        },
        updatingTags: {
            tags: "showEditTagModal",
            invoke: {
                id: "addingTags",
                src: (context, event) => {
                    return TagModule.EditTag(event.tag);
                },
                onDone: { target: "gettingTags", actions: "showEditMessage" },
                onError: { target: "editTags" },
            },
        },
        deleteTag: {
            tags: "showDeleteTagUI",
            on: {
                DELETING_TAG: { target: "deletingTag" },
                CANCEL_TAG: { target: "loadedTags" },
            },
        },
        deletingTag: {
            tags: "showDeleteTagUI",
            invoke: {
                id: "deletingTag",
                src: (context, event) => {
                    return TagModule.DeleteTagById(event.tagId);
                },
                onDone: { target: "gettingTags", actions: ["showSuccessMessage", "setPage"] },
                onError: { target: "loadedTags" },
            },
        },
        serviceUnavailable: {},
    },
}, {
    actions: {
        showSuccessMessage: (context, event) => {
            toaster.ShowSuccess(event.data.successMessages[0]);
        },
        assignSearchData: assign({
            searchData: (context, event) => event.searchData,
        }),
        showAddMessage: (context, event) => {
            toaster.ShowSuccess("Report Tag has been created successfully.");
        },
        showEditMessage: (context, event) => {
            toaster.ShowSuccess("Report Tag has been updated successfully.");
        },
        setPage: assign({
            searchData: (context, event) => {
                if (context.ispageChanged) {
                    return {
                        ...context.searchData,
                        page: context.searchData.page - 1,
                    };
                }
                return context.searchData;
            },
        }),
        ispageChanged: assign({
            ispageChanged: (context, event) => event.ispageChanged,
        }),
    },
    services: {},
});
export default tagsListingMachine;
